// extracted by mini-css-extract-plugin
export default {"form-label":"Textarea_form-label__pWA6n","form-input":"Textarea_form-input__05kf3","form-label__title":"Textarea_form-label__title__bEWD+"};